module.exports = __webpack_public_path__ + "img/teamManage.a3369d95.jpg";